<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
                <div style="display: none !important;">{{ form }}</div>

        <div class="hauer__jasubtitle">Historical Biographies Book</div>
        <div class="hauer__jatitle" v-if="getValue('custom.SpecialEdition')">{{ getValue('custom.SpecialEdition') }}</div>
          <FormSection title="Personal Information">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                      <Consent privacy="https://www.ou.org/privacy-policy/"/>
                  </FormRow> 

            <FormRow inline v-if="getValue('custom.SpecialEdition')">
              <FormCol field="custom.dedication" width="full" :showLabel="false">
                <label class="control-label">Dedication Details </label>
                <FormInput type="textarea" />
              </FormCol>
            </FormRow>
          </FormSection>
          <FormSection title="Billing Information">
            <DonorAddress />
          </FormSection>
          <FormSection title="Payment Information" last>             
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
              <FormRow>
              <ErrorLabel field="amount" />
            </FormRow>

                  <div class="total__section__con" v-if="form.amount">   
                  <div class="total__section">
                      <strong>Total</strong>
                      <div class="total__section__opt">
                        <span v-if="getValue('custom.SpecialEdition')">Historical Biographies Book - {{ getValue('custom.SpecialEdition') }}</span>
                        <MoneyFormat
                        class="amount"
                        :value="tamount"
                        :currencyCode="form.currency"
                      />
                    </div>
                  </div>
                </div> 
          </FormSection>
          <PaymentButton btnText="Submit My Donation" />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import {
  computed,
  defineComponent,
  onMounted,
  ref,
  watch,
} from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";
import { queryParams } from "~/shared/query-params";

export default defineComponent({
  props: {},
  setup() {
    const { setValue, getValue, form } = usePaymentForm();
    const params = queryParams();
    const selectedAmount = ref();
    const selectedDescription = ref();
    const customAmount = ref(form.value.amount);
    const customSelected = ref(false);
    // setValue("amount", "100");
    // selectedAmount.value = 100;

    if (params.amount) {
      setValue("amount", params.amount);
      selectedAmount.value = +params.amount;
      //@ts-ignore
      switch (params.amount) {
        case "36000":
          setValue("custom.SpecialEdition", "Naming");
          break;
        case "7200":
          setValue("custom.SpecialEdition", "Biography dedication");
          break;     
        case "2500":
          setValue("custom.SpecialEdition", "Dedication of inside back page");
          break;          
        case "1800":
          setValue("custom.SpecialEdition", "Quarter page dedications");
          break;
      }
    } else {
      setValue("amount", "1800");
      selectedAmount.value = 1800;
    }

    watch(selectedAmount, (selectedAmount) => {
      if (selectedAmount) {
        customSelected.value = false;

        customAmount.value = null;

        setValue("amount", "" + selectedAmount);
      }
    });

    watch(customSelected, (customSelected) => {
      if (customSelected) {
        selectedAmount.value = null;
        setValue("amount", null);
      }
    });

    watch(customAmount, async (customAmount) => {
      if (customAmount) {
        selectedAmount.value = null;
        customSelected.value = true;
      }

      // make sure UI has vue has dealt with customSelected and then we'll set the customAmount
      // await Vue.nextTick();

      if (!selectedAmount.value) {
        setValue("amount", customAmount || null);
      }
    });


        const tamount = computed(() => {
      //@ts-ignore
      let calculatedAmount = ['wire', 'check'].includes(form.value.gateway)
      ? +form.value.amount!
      : form.value.handleProcessing
        ? Math.round((+form.value.amount! + +form.value.amount! * 0.025) * 100) / 100
        : +form.value.amount!;
      
      if (form.value.periodMonths && form.value.dayOfMonth) {
      calculatedAmount *= +form.value.periodMonths;
      }

      return calculatedAmount;
    });


    return {
      form,
      tamount,
      selectedAmount,
      customAmount,
      customSelected,
      selectedDescription,
      currency: computed(() => form.value.currency),
      getValue,
      setValue,
    };
  },
});
</script>
<style scoped lang="scss">
::v-deep.form-container.ou-donation-form {
  padding: 0px;
  margin: 0px;
  box-shadow: none;
  border: none;
  max-width: 100%;
}
::v-deep h2 {
  font-family: "Proxima Nova" !important;
  font-style: normal;
  font-weight: 700 !important;
  font-size: 16px !important;
  margin-bottom: 16px !important;
  line-height: 24px !important;
  color: #080f16 !important;
}
::v-deep hr {

}
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
::v-deep .radio-inline {
  margin-left: 20px !important;
}

::v-deep .control-label {
  flex: 1;
  max-width: 100%;
  padding-top: 3px;
  line-height: normal;
  padding-bottom: 3px;
  display: block;
  font-size: 14px;
  color: #222;
}
.sponsorship__list {
  display: flex;
  gap: 16px;
  width: 100%;

  @media only screen and (max-width: 500px) {
    flex-flow: column;
  }
}
.amount-row {
  width: 100%;
  flex: 1;

  label {
    cursor: pointer;
    height: 100%;
    width: 100%;
    padding: 20px 24px;
    background: #ffffff;
    border: 2px solid #ebebeb;
    border-radius: 8px;
    &:hover {
      background: #fafafa;
    }
    @media only screen and (max-width: 500px) {
      padding: 10px 14px;
    }
  }
  input {
    height: 0;
    top: 20px;
    position: absolute;
    left: 20px;
    z-index: -1;
    visibility: hidden;
  }

  input[type="radio"]:checked + label {
    border: 2px solid #1e50b4;
    .money_format {
      color: #1e50b4;
    }
    .label-description {
      color: #080f16;
    }
  }
}

.label-description {
  font-family: "Proxima Nova";
  font-style: italic;
  font-weight: 400;
  font-size: 15px;
  line-height: 22px;
  color: #595c5f;
}


.total__section__con {
    margin-top: 20px;
    margin-bottom: 30px;
}

.total__section {
    display: flex;
    max-width: 100%;
    padding: 16px;
    flex-flow: wrap;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
border-radius: 2px;
background: var(--Warning-Light, #FFF8E9);
}

.total__section strong {
color: var(--Grayscale-Ash, #080F16);

/* Desktop/Headline/H7 */
font-family: "Proxima Nova";
font-size: 14px;
font-style: normal;
font-weight: 700;
line-height: 18px; /* 128.571% */
}

.total__section__opt {
    display: flex;
    gap: 8px;
    align-items: center;
color: var(--Grayscale-Ash, #080F16);

/* Desktop/Text/Action - Regular */
font-family: "Proxima Nova";
font-size: 14px;
font-style: normal;
font-weight: 500;
line-height: 20px; /* 142.857% */

    span{
      color: var(--Warning-Dark, #946300);

/* Desktop/Text/Label */
font-family: "Proxima Nova";
font-size: 14px;
font-style: italic;
font-weight: 500;
line-height: 18px; /* 128.571% */
    }
}

::v-deep .payment {
  display: flex;
  align-items: center;
  flex-flow: column;
  justify-content: center;
color: var(--Grayscale-Off-white, #FDFDFD);
text-align: center;

/* Desktop/Text/Action - Regular */
font-family: "Proxima Nova";
font-size: 14px;
font-style: normal;
font-weight: 700;
text-transform: capitalize;
line-height: 20px; /* 142.857% */  
  span{
    display: flex;
    color: var(--Grayscale-Off-white, #FDFDFD);
text-align: center;

/* Desktop/Text/Action - Regular */
font-family: "Proxima Nova";
font-size: 14px;
font-style: normal;
text-transform: capitalize;
font-weight: 700;
line-height: 20px; /* 142.857% */
  }
}

textarea{
  font-family: inherit;
  line-height: normal;
  padding-top: 3px;
  display: block;
  font-size: 14px;
  color: #222;
}

.hauer__jasubtitle{
  color: #885F00;
font-family: "Proxima Nova";
font-size: 14px;
font-style: normal;
font-weight: 700;
line-height: 14px; /* 100% */
letter-spacing: 0.42px;
text-transform: uppercase;
margin-bottom: 8px;
}
.hauer__jatitle{
  color: #17234E;
font-family: "Playfair Display";
font-size: 28px;
font-style: normal;
font-weight: 700;
margin-bottom: 24px;
line-height: 32px; /* 114.286% */
  @media only screen and (max-width: 600px) {
font-size: 20px;
font-style: normal;
font-weight: 700;
margin-bottom: 16px;
line-height: 24px;
  }

        }
</style>
